import React, {useEffect, useState} from "react";
import {useRecoilValue} from "recoil";
import {
    globalBrandConfigState,
    globalBrandModuleSettingState,
    globalCurrentPathState,
    globalIconListState,
    globalUserDetailState,
    globalWebModuleSettingState,
} from "../_common/global_state";
import useShared from "../_common/_shared";
import getSidebarRoute from "../router/sidebarRoute";
import {getRegistrationSettingQuery} from "../api/graphql/auth";
import useLayoutFunction from "./function";
import Layout_1 from "./layout_1";
import Layout_2 from "./layout_2";
import Layout_3 from "./layout_3";
import Layout_4 from "./layout_4";
import Layout_5 from "./layout_5";
import Layout_6 from "./layout_6";

export default function Layouts() {
    const {IconCommon, IconModule, checkUserAccessRight} = useShared();
    const {parseIconName} = useLayoutFunction();

    const [routes, setRoutes] = useState([]);
    const [registerField, setRegisterField] = useState([]);
    const [navMap, setNavMap] = useState({});

    const webModuleSetting = useRecoilValue(globalWebModuleSettingState);
    const brandModuleSetting = useRecoilValue(globalBrandModuleSettingState);
    const iconList = useRecoilValue(globalIconListState);
    const brandConfigState = useRecoilValue(globalBrandConfigState);
    const userDetails = useRecoilValue(globalUserDetailState);
    const globalPathState = useRecoilValue(globalCurrentPathState);

    const hideSidebarChildren = [4, 5, 6].includes(
        brandConfigState?.defaultLayout
    );

    const preloadRoute = async () => {
        const setting = await getSidebarRoute(
            brandConfigState,
            brandModuleSetting,
            webModuleSetting,
            hideSidebarChildren,
            checkUserAccessRight
        );

        const childNavs = brandModuleSetting.filter((d) => d.parent && d.isEnabled);

        //{child:parent}
        const navMap = {};
        childNavs.forEach((n) => {
            navMap[n.name] = n.parent?.name;
        });
        setNavMap(navMap);

        const newSetting = await Promise.all(
            setting.map((item) => {
                let newItem = item;

                if (!!newItem?.sub?.length) {
                    newItem.sub = newItem.sub.map((sub) => ({
                        ...sub,
                        icon: (
                            <IconModule
                                layout={brandConfigState?.defaultLayout}
                                isAlwaysActive={globalPathState === sub.path}
                                className={"sidebarIcon"}
                                iconName={parseIconName(
                                    sub.key,
                                    sub.key === "Wallet" && !([5, 6].includes(brandConfigState?.defaultLayout)) ? "cm" : "md",
                                    brandConfigState?.defaultLayout
                                )}
                                title={sub.label.replace(".", "").replace("/", "").replace(/[-\s+]/g, "_").toLowerCase()}
                            />
                        ),
                    }));
                }

                if ((newItem.key === "home" || newItem.key === "more") && !(brandConfigState?.defaultLayout === 1 || brandConfigState?.defaultLayout === 5)) return {
                    ...newItem,
                    icon: (
                        <IconCommon
                            className={"sidebarIcon"}
                            iconName={parseIconName(
                                newItem?.key,
                                "cm",
                                brandConfigState?.defaultLayout
                            )}
                            title={newItem.label.replace(".", "").replace(/[-\s/+]/g, "_").toLowerCase()}
                            isAlwaysActive={globalPathState === newItem.path}
                            isModule
                        />
                    ),
                }

                return {
                    ...newItem,
                    icon: (
                        <IconModule
                            layout={brandConfigState?.defaultLayout}
                            className={"sidebarIcon"}
                            iconName={parseIconName(newItem?.key, "md", brandConfigState?.defaultLayout)}
                            isAlwaysActive={globalPathState === newItem.path}
                            title={newItem.label.replace(".", "").replace(/[-\s/+]/g, "_").toLowerCase()}
                        />
                    ),
                }
            })
        );

        setRoutes(newSetting);
    };

    const preloadRegisterLiveField = async () => {
        if (userDetails?.clientAccountType === "demo") {
            const response = await getRegistrationSettingQuery("live");
            setRegisterField(response?.getRegistrationSetting?.data);
        }
    };

    useEffect(() => {
        preloadRegisterLiveField();
    }, [userDetails]);

    useEffect(() => {
        preloadRoute();
    }, [brandConfigState, webModuleSetting, iconList, brandModuleSetting, globalPathState]);

    let component;
    const props = {
        kybList: [],
        poiList: [],
        porList: [],
        routes: routes,
        registerField: registerField,
        navMap,
    };

    switch (brandConfigState?.defaultLayout) {
        case 1:
            component = <Layout_1 {...props}/>;
            break;

        case 2:
            component = <Layout_2 {...props}/>;
            break;

        case 3:
            component = <Layout_3 {...props}/>;
            break;

        case 4:
            component = <Layout_4 {...props}/>;
            break;

        case 5:
            component = <Layout_5 {...props}/>;
            break;

        case 6:
            component = <Layout_6 {...props}/>;
            break;

        default:
            component = <Layout_2 {...props}/>;
            break;
    }

    return component;
}
